// Adamar's official verification post: a creator proves they own their Instagram by
// commenting their ADAMAR-XXXXXX code under it (checked automatically by claims-auto-verify).
// Brands no longer verify anything — since 28.10.2026 a business just adds the brands it tracks.
export const CREATOR_VERIFY_POST_URL = 'https://www.instagram.com/p/DbGzESCoPDV/';
export const CREATOR_OFFICIAL_HANDLE = 'adamar_ai';  // display only; the verify post lives on @adamar_ai
